export default{
    NAME: 'ufp-react-redux-router4',
    REDUCER_NAME: 'router'
}
